import {SectionTitle, InputTitleNormal} from '../../common/TitleStyle'
import styled from '@emotion/styled'
import {Box, IconButton, Grid} from '@mui/material'
import TextField from '@mui/material/TextField'

const ProjectDescriptionTitle = styled(SectionTitle)(() => ({
  marginBottom: '16px',
  marginLeft: '8px'
}))

const RequirementsBlock = styled('div')(({theme}) => ({
  width: '400px',
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.hpBlack,
  borderRadius: '4px',
  height: '100px',
  marginLeft: '8px'
}))

const RequirementsRow = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginLeft: '24px',
  fontSize: theme.typography.subtitle2.fontSize
}))

const ProjectDetailsRow = styled(RequirementsRow)(() => ({
  marginLeft: '0px'
}))

const InputError = styled(InputTitleNormal)(({theme}) => ({
  color: theme.palette.hpAccentRed,
  fontSize: theme.typography.subtitle2.fontSize,
  width: '320px',
  marginLeft: '8px'
}))

const EditButton = styled(IconButton)(({theme}) => ({
  marginLeft: '8px',
  '&:hover': {
    backgroundColor: theme.palette.hpPrimaryLightest
  }
}))

const StyledGrid = styled(Grid)(() => ({
  marginLeft: '-4px'
}))

const ProjectDescField = styled(TextField)(() => ({
  width: '100%',
  height: 'auto',
  padding: '5px 8px'
}))

const StyledInlineRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
}))

const ProjectDetailsGridContainer = styled(Grid)(({theme}) => ({
  marginTop: theme.spacing(0.5)
}))

const StyledProjectDetailsContainer = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(1)
}))

export {
  ProjectDescriptionTitle,
  RequirementsBlock,
  RequirementsRow,
  ProjectDetailsRow,
  InputError,
  EditButton,
  ProjectDescField,
  StyledGrid,
  StyledInlineRow,
  ProjectDetailsGridContainer,
  StyledProjectDetailsContainer
}
